import { graphql } from "gatsby";
import { CheckboxesBasic, CheckboxesInline } from "../../../../src/examples/components/Checkboxes";
import * as React from 'react';
export default {
  graphql,
  CheckboxesBasic,
  CheckboxesInline,
  React
};